import { IPricingTooltip } from '../interfaces/IPricingTooltip';

const PRICING_PREMIUM_TOOLTIPS: IPricingTooltip[] = [
  {
    id: 1,
    title: 'Advanced export files',
    subTitle: '(.esx, .skp, .dwg, .dxf)',
    tooltip:
      'Export all measurement data to XLS, JSON, XML and PDF and all 3D model data to popular CAD types: SKP, DXF, DWG, ESX',
  },
  {
    id: 2,
    title: 'Software Integrations',
    tooltip:
      'Eliminate manual data entry by integrating seamlessly with JobNimbus, JobProgress, Acculynx, and CoreLogic, among others',
  },
  {
    id: 3,
    title: 'Unlimited Property Storage',
    tooltip:
      'Keep all your projects, measurements and 3D models in a single place for free',
  },
  {
    id: 4,
    title: 'Proposals and contracts',
    tooltip:
      'Automatically populate your contract templates and get digital signatures while onsite',
  },
  {
    id: 5,
    title: 'Priority dedicated support',
    tooltip:
      'Jump to the front of the line with priority support queues. Talk to an assigned Account Manager for questions about the product or your business.',
  },
];

export default PRICING_PREMIUM_TOOLTIPS;
